module.exports = __webpack_public_path__ + "static/media/e06a573355c490f7ce6e3125ac01db81.e06a5733.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/e06a573355c490f7ce6e3125ac01db81.svg
// module id = 1081
// module chunks = 21